// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"51c69637","559":"aba13753","574":"e3784d75","879":"982d24a0","962":"a16f9941"}[chunkId] + ".chunk.js";
};